export default __webpack_public_path__ + "static/media/golfer-eps.d86cad06.png";